import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'


import { brandName } from 'helpers/brand'

/**
 * Ishlab chiqarish bo'limi YON MENYUSI (chap tomonda).
 *
 * NEGA: ilgari hamma o'tish tugmasi TEPADA bir qatorda turardi — 7 ta tugma,
 * 5 xil rang, faol sahifa ajralmasdi, rus tilida qator sig'masdi.
 * Endi egasi/adminникi kabi chap tomonda, ketma-ketlikda (user qarori 2026-08-01).
 *
 * Tuzilishi ATAYLAB bir darajali — egasining ikki darajali (piktogramma ustuni +
 * ochiladigan panel) menyusi bu yerda ortiqcha: bandlar kam, hammasi bir ko'rinishda
 * sig'adi.
 */
export const SIDEBAR_W = 240

function Sidebar() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const reduxAccount = useSelector(state => state.account)
	const role = localStorage.getItem('role')
	/* TARIF CHEKLOVI. Kadrlar bo'limlari `sec.employees` / `sec.attendance`
	   tarifiga bog'liq (routes/api.php dagi `section:` middleware). Tarifda
	   yo'q bo'lsa bandni KO'RSATMAYMIZ — aks holda rahbar bosadi-yu 403 oladi.
	   Egasining menyusi ham xuddi shunday ishlaydi (owner/SidebarContent.js:48).
	   ⚠️ Ruxsatlar hali kelmagan bo'lsa (bo'sh massiv) BLOKLAMAYMIZ — menyu
	   bo'm-bo'sh qolib ketmasin; haqiqiy himoya baribir backendда. */
	const permNames = (reduxAccount.permissions || []).map(p => p.name)
	const hasSec = key => permNames.length === 0 || permNames.includes(key)

	const brandTitle = brandName()

	const isManager   = role === 'ROLE_PROD_MANAGER'
	const isWorkshop  = role === 'ROLE_WORKSHOP'
	const isWarehouse = role === 'ROLE_WAREHOUSE'

	// «Rulonni ochish» — o'tish emas, AMAL. Modalning O'ZI Header'da qoladi
	// (u kategoriyalar daraxti bilan murakkab); bu yerdan faqat ochilish signali beriladi.
	// Qayta yozish o'rniga signal — ishlaydigan kodga tegilmaydi.
	function openRolls() {
		window.dispatchEvent(new Event('workshop:open-rolls'))
	}

	const groups = [
		{
			title: t('daily_work_group'),
			items: [
				/* ⚠️ КЕНГАШ — Pro imkoniyati (`sec.production_board`), 2026-08-13.
				   Ilgari `show: true` edi: Start tenantда menyuda turardi-yu,
				   bosilganda 403 sahifasi chiqardi. Endi tarifga qarab
				   ko'rsatiladi — bo'lmagan narsa menyuda ham turmaydi. */
				{ path: '/workshop/board', i18n: 'board', icon: 'uil-apps', show: hasSec('sec.production_board') },
				/* OMBORCHI sahifasi — chiqarishga tayyor cheklar. Ilgari menyuda
				   UMUMAN yo'q edi va omborchi faqat Кенгашga tayanardi; u yopilsa
				   akkaunt o'lik bo'lib qolardi. */
				{ path: '/warehouse', i18n: 'warehouse', icon: 'uil-truck', show: isWarehouse },
				{ path: '/workshop', i18n: 'cheques', icon: 'uil-receipt', show: !isWarehouse },
				{ path: '/workshop/documents-preparation', i18n: 'preparation', icon: 'uil-box', show: !isWarehouse },
				// «Kunlik ish» — faqat USTA to'ldiradi (user qarori: rahbarga kerak emas)
				{ path: '/workshop/daily-work', i18n: 'daily_work', icon: 'uil-file-check-alt', show: isWorkshop },
			],
		},
		{
			/* ═══ OMBOR — OMBORCHI UCHUN (2026-08-24) ═══
			   Ilgari omborchi menyuda ATIGI 2 band ko'rardi va ombor
			   ekranlarining birortasiga ham kira olmasdi: qabul, tayyorlash,
			   inventarizatsiya, qoldiq — hammasi faqat egada edi. Ya'ni
			   omborchi akkaunti amalda faqat Кенгашга tayanardi.

			   ⚠️ Ruxsatlar: backendда bu ekranlar ALLAQACHON ochiq
			      (`SectionAccess` faqat TARIFNI tekshiradi, rolni emas) —
			      ya'ni yangi ruxsat ochilmayapti, shunchaki menyuda
			      ko'rsatilyapti. `sec.warehouse_finished` Pro/Full da,
			      qolganlari Start da ham bor. */
			title: t('warehouse_group'),
			items: [
				{ path: '/stock-levels',          i18n: 'stock_levels',       icon: 'uil-shield-check',   show: isWarehouse && hasSec('sec.warehouse_finished') },
				{ path: '/supplier-orders',       i18n: 'supplier_orders',    icon: 'uil-telegram',       show: isWarehouse && hasSec('sec.supplier_orders') },
				{ path: '/warehouse-finished',    i18n: 'warehouse_finished', icon: 'uil-archive',        show: isWarehouse && hasSec('sec.warehouse_finished') },
				{ path: '/documents-preparation', i18n: 'preparation',        icon: 'uil-box',            show: isWarehouse && hasSec('sec.documents_preparation') },
				{ path: '/inventory',             i18n: 'inventory',          icon: 'uil-clipboard-alt',  show: isWarehouse && hasSec('sec.inventory') },
				{ path: '/write-off',             i18n: 'write_off',          icon: 'uil-trash-alt',      show: isWarehouse && hasSec('sec.write_off') },
				{ path: '/report-balance',        i18n: 'balance2',           icon: 'uil-chart-pie-alt',  show: isWarehouse && hasSec('sec.report_balance') },
			],
		},
		{
			title: t('oversight_group'),
			items: [
				{ path: '/workshop/dashboard', i18n: 'oversight', icon: 'uil-chart-pie', show: isManager },
				{ path: '/workshop/report', i18n: 'report', icon: 'uil-message', show: isManager },
				/* ⚠️ SHIKOYATLAR — backend allaqachon ruxsat berardi: `hr:cashbox.complaints`
				   qo'riqchisi ROLE_PROD_MANAGER ni ROL bo'yicha o'tkazadi (HrAccess:29).
				   Lekin bu yerda band ham, `workshopRoutes` da yo'l ham yo'q edi —
				   ya'ni rahbar (HR) bo'limga umuman kira olmasdi, /workshop ga
				   qaytarilardi. Xodim galochkasi ham chiqmaydi: galochkalar ro'yxati
				   FAQAT sotuvchi/kassir rolida ko'rsatiladi (employees/Index.js:605). */
				{ path: '/complaints', i18n: 'complaints', icon: 'uil-comment-exclamation', show: isManager && hasSec('sec.complaints') },
			],
		},
		{
			// KADRLAR — egasidagi tartib bilan bir xil (owner/menu.js:310-350),
			// oxirida davomat sozlamasi (user talabi 2026-08-01).
			title: t('hr_group'),
			items: [
				/* ⚠️ XODIM / LAVOZIM / BO'LIM bandlari OLIB TASHLANDI (2026-09-05,
				   egasining qarori). Sabab — rol eskalatsiyasi: sex rahbari xodim
				   yarata olgani uchun o'ziga DIREKTOR akkaunt ochib (yoki mavjud
				   direktorning parolini almashtirib) o'zidan yuqori huquqqa
				   ko'tarilardi (direktor chek pulini oladi, i.ch. rahbari olmaydi).
				   Backend ham yopildi: `roles:ROLE_OWNER,ROLE_DIRECTOR`
				   (routes/api.php — /employees, /employee-list, /employees-types,
				   /departments). Menyudan olib tashlanmasa band ko'rinib turib
				   403 berardi.
				   DAVOMAT, KPI va XODIM HISOBI ATAYLAB QOLDIRILDI — bular sex
				   rahbarining kundalik ishi, eskalatsiyaga aloqasi yo'q. */

				/* ⚠️ O'Z ruxsati bilan tekshiriladi (2026-08-13). Ilgari ikkalasi ham
				   `sec.employees` ni ko'rardi — u Startda BOR, kerakli
				   `sec.employee_account` / `sec.kpi` esa faqat Pro/Full da.
				   Natijada sex rahbari bandni ko'rardi, bosganda jadval
				   sarlavhalari chizilib ichi bo'sh qolardi + qizil toast. */
				{ path: '/employee-account', i18n: 'employee_account', icon: 'uil-transaction',  show: isManager && hasSec('sec.employee_account') },
				{ path: '/kpi',              i18n: 'kpi',              icon: 'uil-chart-line',   show: isManager && hasSec('sec.kpi') },
				{ path: '/attendance',       i18n: 'attendance',       icon: 'uil-calendar-alt', show: isManager && hasSec('sec.attendance') },
				{ path: '/attendance-setup', i18n: 'attendance_setup', icon: 'uil-clock',        show: isManager && hasSec('sec.attendance') },
			],
		},
	]

	const visible = groups
		.map(g => ({ ...g, items: g.items.filter(i => i.show) }))
		.filter(g => g.items.length > 0)

	return (
		<>
			{/* ⚠️ `vertical-menu` klassi ISHLATILMAYDI: verical.css:288 da
			    `width: 50px !important` bor (egasining piktogramma ustuni uchun) va u
			    250px ni bekor qiladi — menyu siqilib, matn kesilib qolardi.
			    Shu sabab o'lchamlar shu yerda, to'g'ridan-to'g'ri beriladi. */}
			<div style={{
				position: 'fixed', top: 0, bottom: 0, left: 0, width: SIDEBAR_W,
				background: 'var(--ws-side-bg, #fff)', borderRight: '1px solid var(--ws-side-line, #e9ecf2)', zIndex: 1002,
				display: 'flex', flexDirection: 'column',
			}}>
				<div className="d-flex align-items-center px-3"
					style={{ height: 70, borderBottom: '1px solid var(--ws-side-line2, #f1f3f7)', flexShrink: 0 }}>
					{/* Korxonaning O'Z brendi (izoh: helpers/brand.js).
					    Zaxira: logotip -> nom (matn) -> ilova belgisi. */}
					<span className="cursor ws-brand" onClick={() => navigate('/workshop/board')}>
						{/* MAHSULOT LOGOTIPI (Tameer) — egasining qarori 2026-09-10.
							    Korxona nomi ostida kichik matn bo'lib qoladi. */}
						<img src="/tameer-logo.png" alt="Tameer" style={{ maxWidth: 150, maxHeight: 34 }} />
						{brandTitle &&
							<div className="text-muted" style={{ fontSize: 11, marginTop: 2 }}>{brandTitle}</div>}
					</span>
				</div>

				<div style={{ overflowY: 'auto', paddingBottom: 20, flex: 1 }}>
					{visible.map((g, gi) => (
						<div key={gi} className="mb-2">
							<div className="text-muted fw-600 px-3 pt-3 pb-1"
								style={{ fontSize: 10.5, letterSpacing: '1.2px' }}>
								{g.title}
							</div>

							{g.items.map((it, i) => (
								<NavLink key={i} to={it.path} end={it.path === '/workshop'}
									className={({ isActive }) =>
										'd-flex align-items-center gap-2 px-3 py-2 text-decoration-none ' +
										(isActive ? 'fw-600' : '')}
									style={({ isActive }) => ({
										color: isActive ? 'var(--ws-side-on, #5b2be7)' : 'var(--ws-side-ink, #3a4150)',
										background: isActive ? 'rgba(91,43,231,.10)' : 'transparent',
										borderLeft: '3px solid ' + (isActive ? '#5b2be7' : 'transparent'),
										fontSize: 14,
									})}>
									<i className={it.icon} style={{ fontSize: 18, width: 22 }}></i>
									<span>{t(it.i18n)}</span>
								</NavLink>
							))}
						</div>
					))}

					{!isWarehouse &&
						<div className="px-3 pt-3 mt-2" style={{ borderTop: '1px solid var(--ws-side-line2, #eef0f4)' }}>
							<button className="btn btn-outline-dark w-100" onClick={openRolls}>
								<i className="uil-cube me-1"></i>{t('open_roll')}
							</button>
						</div>}
				</div>
			</div>

		</>
	)
}

export default Sidebar
